<template>
    <o-modal :dialogClass="'import-modal-size'" @showModal="showModal" @close="closeModal">
        <template v-slot:header>
            {{ modalTitle }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="alert alert-danger">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
                <o-form-group name="uploadFile" class="text-start mb-4">
                    <label for="uploadFile" class="mb-3 fw-semibold">Upload File <span class="text-danger">*</span></label>
                    <o-import-file v-model="file" @selectFile="fileSelected"/>
                    <div class="mt-3 text-center" style="font-size: 13px;">
                        Need a template? 
                        <a href="#" @click.prevent="$emit('downloadTemplate')" class="primary-text text-decoration-none fw-semibold" style="color: var(--primary-color) !important;">
                            <i class="fas fa-download me-1"></i> Download Here
                        </a>
                    </div>
                </o-form-group>
                
                <div class="alert alert-info text-start mb-0 mt-2" style="font-size: 12px;">
                    <div class="mb-1"><i class="fas fa-info-circle me-2"></i><strong>Validation Rules:</strong></div>
                    <ul class="mb-0 ps-4">
                        <li><strong>Required Fields:</strong> First Name, Last Name, Email, Country, and Phone.</li>
                        <li><strong>Email:</strong> Must be in a valid format (e.g., user@example.com).</li>
                        <li><strong>Password:</strong> Optional. If provided, it must be 6-16 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.</li>
                    </ul>
                </div>

                <div class="d-flex justify-content-between mt-4">
                    <button @click="closeModal" class="btn btn-light text-white px-4 fw-medium" type="button" style="background-color: #B9B9B9; border: none;">Cancel</button>
                    <o-button @click="importFile" :variant="'primary'" type="button" class="px-4 text-white">Import</o-button>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OButton, OImportFile } from '@/components/OmnihControl';
import { mapActions } from 'vuex';

export default {
    name: 'ImportMember',
    components: {
        OImportFile,
        OModal,
        OForm,
        OFormGroup,
        OButton,
    },
    data() {
        return {
            file: null, 
            errors: [],
            modalTitle: 'Import Member', 
        };
    },
    methods: {
        ...mapActions('member', ['import']),

        closeModal() {
            this.$emit('closeModal');
        },
        fileSelected(file) {
            this.file = file;
        },
        importFile() {
            this.errors = [];

            if (!this.file) {
                this.errors.push('File is required.');
                return;
            }

            const formData = new FormData();
            formData.append('file', this.file);
            this.$emit('saveDetail', formData);
            this.closeModal();
        }
    },
}
</script>

<style scoped>
    .spinner{
        position: fixed;
        z-index: 3;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.5);
        height: 100%;
        width: 100%;
    }
    .spinner-position{
        display: block;
        position: fixed;
        z-index: 1031;
        top: 50%;
        right: 50%;
        margin-top: 5px; 
        margin-left: 80px; 
    }

    :deep(.import-modal-size) {
        min-width: 500px;
    }
</style>
